module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"test":"тест","passed":"пройден","notPassed":"не пройден","explanation":"Уточняющий","cutoff":"Отсекающий","noAnswer":"Нет ответа","timeSpent":"Затрачено времени","correctAnswer":"правильный ответ","pointsScored":"Набрано баллов","outOf":"из","passing":"Проходной"}}')
  delete Component.options._Ctor
}
